import { Popover } from "@headlessui/react";
import { Trans } from "react-i18next";
import { t } from "i18next";
import { Button } from "../../ui/components/Button";
import { useAdminSelector } from "../../../stores/AdminStore";
import { useNavigate } from "react-router-dom";

export const UserPopover = () => {
  const {name, username, initials} = useAdminSelector(s => s.auth);
  const navigate = useNavigate();

  const handleSignOut = () => {
    navigate(`/sign-out?from=${location.pathname}`);
  };

  return (
    <Popover>
      <Popover.Button className="w-8 h-8 md:w-14 md:h-14 p-1.5 md:p-3 text-lg
        md:text-3xl" title={t`User`}>
        <div className="rounded md:rounded-lg bg-white w-full h-full text-black
          flex justify-center items-center font-unleashed">
          {initials}
        </div>
      </Popover.Button>
      <Popover.Panel className="absolute z-40 right-0 w-full md:w-96 bg-white
        text-black border border-gray-400">
        <div className="flex items-center border-b border-gray-400 p-2">
          <div className="flex justify-center items-center text-4xl
            font-unleashed border border-black w-14 h-14 mr-2 rounded-xl">
            {initials}
          </div>
          <div>
            <div className="font-semibold">
              {name}
            </div>
            <div>
              {username}
            </div>
          </div>
        </div>
        <ul className="space-y-2 p-2">
          {/*FIXME Implement later*/}
          {/*<li>*/}
          {/*  <Link to={""} text={t`Change Password`}/>*/}
          {/*</li>*/}
          <li>
            <Button
              className="text-gray-500 underline [@media(pointer:fine)]:hover:text-unleashed-pink"
              variant="none" onClick={handleSignOut} title={t`Sign Out`}>
              <Trans>Sign Out</Trans>
            </Button>
          </li>
        </ul>
      </Popover.Panel>
    </Popover>
  );
};
